import React, { useEffect } from 'react';
import './PlayerModal.css';
import ImageUpload from './ImageUpload';

const PlayerModal = ({ player, onClose, isAdmin, round, matchId, playerNumber, onUploadSuccess }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  if (!player) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-body">
          <div className="player-modal-image-container">
            <img 
              src={player.image || 'https://via.placeholder.com/200?text=Player'} 
              alt={player.name}
              className="player-modal-image"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/200?text=Player';
              }}
            />
          </div>
          <h2 className="player-modal-name">{player.name}</h2>
          {player.note && (
            <p className="player-modal-note">{player.note}</p>
          )}
          {isAdmin && (
            <ImageUpload
              player={player}
              round={round}
              matchId={matchId}
              playerNumber={playerNumber}
              onUploadSuccess={onUploadSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PlayerModal;
